import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environment/environment';
import { Webshop } from '@models/webshop.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WebshopService {
  private readonly http = inject(HttpClient);
  private readonly ENDPOINT = 'webshops';

  getAll(): Observable<Webshop[]> {
    return this.http.get<Webshop[]>(`${environment.apiBaseUrl}/${this.ENDPOINT}`);
  }

  get(id: string): Observable<Webshop> {
    return this.http.get<Webshop>(`${environment.apiBaseUrl}/${this.ENDPOINT}/${id}`);
  }

  create(webshop: Webshop): Observable<Webshop> {
    return this.http.post<Webshop>(`${environment.apiBaseUrl}/${this.ENDPOINT}`, webshop);
  }

  update(webshop: Partial<Webshop> & { id: string }): Observable<Webshop> {
    return this.http.patch<Webshop>(`${environment.apiBaseUrl}/${this.ENDPOINT}/${webshop.id}`, webshop);
  }

  delete(id: string): Observable<string> {
    return this.http.delete<string>(`${environment.apiBaseUrl}/${this.ENDPOINT}/${id}`);
  }
}
